<template>
	<c-dialog ref="dialog" :title="this.workTypeName+'操作记录'" enable-flex width="1000" mode="slide" mask-close :button="false" @close="$refs.window.hide()">
		<m-search ref="search" column="4" @search="searchHandle" :default-data="defaultSearchData">
			<m-search-item label="操作详情">
				<c-input name="remark" placeholder="请输入"></c-input>
			</m-search-item>
			<m-search-item label="操作时间" colspan="2">
				<c-datetime start-name="start_date" end-name="end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</m-search-item>
<!--				<m-search-item label="操作用户">
				<c-datetime start-name="start_date" end-name="end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</m-search-item>-->
			<m-search-item label="操作类型">
				<c-select name="operation_types" :options="operationName" multiple ></c-select>
			</m-search-item>
		</m-search>

		<c-table ref="list" height="grow">
			<c-table-column
				label="操作时间"
				name="create_date"
				width="120"
			></c-table-column>

			<c-table-column
				label="操作用户"
				name="create_user_realname"
				width="120"
			>
			</c-table-column>

			<c-table-column
				label="操作类型"
				name="operation_type"
				width="70"
			>
				<template #default="{data}">
					<c-state dict="operationName" :value="data.operation_type"></c-state>
				</template>
			</c-table-column>

			<c-table-column
				label="操作详情"
				width="400"
				:ellipsis="false"
			>
				<template #default="{data}">
					<span>{{data.remark}}</span>
					<c-link v-if="data.data_list && data.data_list.length > 0" :ref="`detail${data.id}`" @click="detailHandle(data)">【查看详细数据】</c-link>
					<span v-else>，未修改任何数据</span>
				</template>
			</c-table-column>
		</c-table>

		<c-window ref="window" title="详细数据" align="end" height="240">
			<ul class="logs-list">
				<li v-for="(item, i) in detailData" :key="i">{{item}}</li>
			</ul>
		</c-window>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'workLogDetail',

		computed: {
			// 获取dictName选项数据
			...mapState(['operationName']),
            workTypeName() {
                return {
                    1: '【销售订单】',
                    2: '【生产计划】',
                    3: '【工单】',
                    4: '【入库单】',
                    5: '【出库单】',
                    6: '【盘点单】',
                    7: '【产品信息】',
                    8: '【不良品项】',
                    9: '【工序】',
                    10: '【工艺路线】',
                    11: '【客户】',
                    12: '【供应商】',
                    13: '【任务】',
                    14: '【报工】',
                    15: '【物料清单】',
                    16: '【库存收发明细】',
                    17: '【库存余额】',
                    18: '【库存余额明细】',
                    19: '【进销存汇总】',
                    25: '【库存变更记录】',
                    26: '【仓库】',
                    27: '【用户】',
                    29: '【委外单】',
                    31: '【绩效工资配置】',
                    32: '【发货单】',
                    34: '【装配工单】',
                    35: '【委外动态】',
                    36: '【委外结算单】',
                    39: '【采购单】',
                    45: '【生产入库检】'
                }[this.workType]
            }
		},

		props: {
			workType: [String, Number]
		},

		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					start_date: new Date(now.getFullYear(), now.getMonth(), 1).format('yyyy-MM-dd') +' 00:00',
					end_date: new Date(now.getFullYear(), now.getMonth() + 1, 0).format('yyyy-MM-dd')+' 23:59'
				},
				detailData: []
			}
		},
		
		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				data.work_type_id = this.workType;
				this.$refs.list.load({
					url: '/sys/work/log/list',
					data,
					dataFormatter: data => {
						data.forEach(item => {
							if (!item.data_json||item.data_json.length==0) return;
							if (item.operation_type == 2) {
								item.data_list = item.data_json.map(item => {
									return `【${item.字段}】: 【${item.原值 || '空'}】 → 【${item.新值 || '空'}】`;
								});
							} else {
								item.data_list = item.data_json.map(item => {
									let key = Object.keys(item)[0];
									return `${key}：${item[key]}`;
								});
							}
						});
						return data;
					}
				});
			},
			/************打开新增、编辑弹窗**************/
			open() {
				this.searchHandle();
				this.$refs.dialog.open();
			},

			detailHandle(data) {
				this.detailData = data.data_list;
                const d1 = new Date('2026-05-08 20:10:00').getTime();
                const d2 = new Date(data.create_date).getTime();
                //历史数据查询接口获取数据
                if(d1 > d2){
                    this.request({
                        url: '/sys/work/log/detail',
                        data: {
                            work_type_id: this.workType,
                            id: data.id
                        },
                        success: detail => {
                            console.log("----------detail---------------");
                            console.log(detail);
                            console.log("----------detail.data_json---------------");
                            console.log(detail.data_json);
                            var data_list = [];
                            if (detail.data_json && detail.data_json.length > 0) {
                                if (detail.operation_type == 2) {
                                    data_list = detail.data_json.map(item => {
                                        return `【${item.字段}】: 【${item.原值 || '空'}】 → 【${item.新值 || '空'}】`;
                                    });
                                } else {
                                    data_list = detail.data_json.map(item => {
                                        let key = Object.keys(item)[0];
                                        return `${key}：${item[key]}`;
                                    });
                                }
                            }
                            this.detailData = data_list;
                            this.$refs.window.show(this.$refs[`detail${data.id}`]);
                        }
                    });
                }else {
                    this.$refs.window.show(this.$refs[`detail${data.id}`]);
                }
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.logs-list {
		padding: 10px 10px;

		li {
			padding: 4px 0;
			line-height: 16px;
			font-size: 13px;
			color: #666;
		}
	}
</style>
